import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import Loader from './components/Loader';

// Обертка для страниц, доступных ТОЛЬКО авторизованным (Dashboard, Profile и т.д.)
export const ProtectedRoute = ({ children }) => {
  const { currentUser, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <Loader />; // Ждем окончания fetchCurrentUser

  if (!currentUser) {
    // Редирект на главную, запоминая, куда пользователь хотел попасть
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Если у вас есть логика с qrcode (tgsecretkey есть, а tg_user_id нет):
  // if (currentUser.tgsecretkey && !currentUser.tg_user_id && location.pathname !== "/qrcode") {
  //   return <Navigate to="/qrcode" replace />;
  // }

  return children;
};

// Обертка для страниц, доступных ТОЛЬКО ГОСТЯМ (Login, Register). 
// Авторизованных перекинет на /dashboard
export const PublicOnlyRoute = ({ children }) => {
  const { currentUser, loading } = useContext(AuthContext);

  if (loading) return <Loader />;

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};
